import { createRouter, createWebHashHistory, Router, RouteRecordRaw } from 'vue-router';

import * as routerHook from '@/router/routerHook';

import routerPublic from '@/router/routerPublic';
import index from '@/router/index';
import sign from '@/router/sign';
import delivery from '@/router/delivery';
import auth from '@/router/auth';
import transitionExtend from '@/router/transition-extend'; // 引入扩展函数(路由动画)

const routes: Array<RouteRecordRaw> = [...index, ...sign, ...delivery, ...routerPublic,...auth];

let router: Router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 设置token
routerHook.setToken(router);
// 校验token
routerHook.checkToken(router);
// 获取用户权限
// routerHook.getPermission(router);
// 路由钩子 设置页面缓存
routerHook.setKeepAlive(router);
// 路由钩子 设置页面title
routerHook.setTitle(router);
// 对router对象扩展(路由动画)
router = transitionExtend(router);

export default router;
